import React from 'react';

import Code from '@atlaskit/code/code';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';

import ExampleBox from '../shared/example-box';

export default function Example(): React.JSX.Element {
	return (
		<Stack alignInline="start" space="space.100">
			<Inline grow="hug">
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */}
				<ExampleBox style={{ display: 'block', flexGrow: 1 }}>
					Wrapping <Code>Inline</Code> is set to <Code>grow="hug"</Code>
				</ExampleBox>
			</Inline>
			<Inline grow="fill">
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */}
				<ExampleBox style={{ display: 'block', flexGrow: 1 }}>
					Wrapping <Code>Inline</Code> is set to <Code>grow="fill"</Code>
				</ExampleBox>
			</Inline>
		</Stack>
	);
}
